import axios from "axios";
import { CONFIG } from "../const/config";
export const http = axios.create({
  baseURL: CONFIG.baseUrl,
  headers: {
    Accept: "application/json",
  },
});
